<template>
  <div class="container">

    <!--刻度尺-->
    <div v-if="!isHorizontal" class="left-ruler ruler">
      <div v-for="list in era" class="i">{{list}}<em></em></div>
    </div>
    <div v-if="!isHorizontal" class="right-ruler ruler">
      <div v-for="list in era" class="i">{{list}}<em></em></div>
    </div>

    <div class="typography">
      <div class="l">
        <span>选择排版方式：</span>
        <i @click="isHorizontal=true;" :class="isHorizontal ? 'checked' : ''">水平排版</i>
        <i @click="isHorizontal=false;" :class="isHorizontal ? '' : 'checked'">垂直排版</i>
      </div>
      <div class="r">
        <input v-model="viewRatio" min=".3" step=".001" max="1" type="range">
      </div>
    </div>

    <div :class="[isHorizontal ? 'horizontal' : 'vertical']" class="node-wrapper">
      <tree-node :datas="data1" :select="selectOne" :style="{'zoom': viewRatio}"></tree-node>
    </div>

    <transition name="fade">
      <div v-if="maskShow" class="mask-box">
        <div @click="maskShow=false;" class="bg"></div>
        <div class="mask">
          <div @click="maskShow=false;" class="close"></div>
          <div class="inner">
            <div class="inner-scroll">
              <ul class="tab">
                <li @click="tabOne(0)" :class="{'on': tabIndex===0}">个 人</li>
                <li @click="tabOne(1)" :class="{'on': tabIndex===1}">配 偶</li>
              </ul>
              <div class="top">
                <div v-if="selectedObj.img_url" class="l">
                  <div class="img-cover"
                       :style="{'background-image': 'url(' + BG_IMG(selectedObj.img_url) + ')'}"></div>
                </div>
                <div class="r">
                  <div>
                    <span>姓名：</span>{{selectedContents.name}}
                  </div>
                  <div>
                    <span>字号：</span>{{selectedContents.word_name}}
                  </div>
                  <div>
                    <span>性别：</span>
                    <i v-if="selectedContents.gender === 1">男</i>
                    <i v-if="selectedContents.gender === 2">女</i>
                  </div>
                  <div>
                    <span>配偶：</span>{{selectedContents.partner}}
                  </div>
                  <div>
                    <span>生于：</span>{{selectedContents.birthday}}
                  </div>
                  <div v-if="selectedContents.died_in">
                    <span>卒于：</span>{{selectedContents.died_in}}
                  </div>
                </div>
              </div>
              <div class="bottom">
                <div class="tit">个人简介</div>
                <div v-html="(selectedContents.description || '').replace(/\n/g,'<br/>')">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
  import $ from 'jquery'
  import config from '../config'
  import treeNode from './tree-node.vue'
  import relationData from './relation.json'

  function getDistance(p1, p2) {
    var x = p2.pageX - p1.pageX,
        y = p2.pageY - p1.pageY
    return Math.sqrt((x * x) + (y * y))
  }

  function findId2Insert(obj, temp) {
    if (obj.id === temp.other_parent_id) {
      obj.children || (obj.children = [])
      obj.children.push(temp)
    }
    else if (obj.children) {
      for (let i = 0, len = obj.children.length; i < len; i++) {
        findId2Insert(obj.children[i], temp)
      }
    }
  }

  export default {
    name      : 'tree',
    mounted() {
      if (this.$el.offsetWidth < 768) {
        this.nodeEl = document.querySelector('.node-wrapper')
        this.smallSizeInit()
      }
      else {
        this.nodeEl = document.querySelector('body')
      }
      this.getRelation()
      //this.getLocalRelation()
    },
    data() {
      return {
        data1           : null,
        isHorizontal    : false,
        maskShow        : false,
        era             : ['第十四代', '第十五代', '第十六代', '第十七代', '第十八代', '第十九代', '第二十代', '第二十一代', '第二十二代', '第二十三代',],
        viewRatio       : 1,
        selectedObj     : null,
        tabIndex        : 0,
        selectedContents: {},
        nodeEl          : null,
      }
    },
    methods   : {
      BG_IMG(val) {
        if (val) {
          return config.fileManagerPrefix + val
        }
        else {
          return ''
        }
      },
      smallSizeInit() {
        let isTouch = false,
            tempRatio,
            start   = [],
            temp

        this.viewRatio = .5

        document.addEventListener('touchstart', e => {
          if (e.touches.length >= 2) {
            start     = e.touches
            isTouch   = true
            tempRatio = this.viewRatio
          }
        }, false)

        document.addEventListener('touchmove', e => {

          if (e.touches.length >= 2 && isTouch) {
            e.preventDefault()
            let now   = e.touches
            let scale = Number((getDistance(now[0], now[1]) / getDistance(start[0], start[1])).toFixed(3))
            temp      = tempRatio * scale

            if (temp > 1) {
              temp = 1
            }
            else if (temp < .3) {
              temp = .3
            }

            this.viewRatio = temp

          }
        }, false)

        document.addEventListener('touchend', () => {
          if (isTouch) {
            isTouch = false
          }
        }, false)
      },
      selectOne(obj) {
        this.selectedObj = obj
        this.maskShow    = true
        this.tabIndex    = 0
        this.tabOne(this.tabIndex)
      },
      tabOne(index) {
        let reg = /^p_(.*)/

        this.tabIndex         = index
        this.selectedContents = {}

        for (let i in this.selectedObj) {
          if (index === 0 && !reg.test(i)) {
            this.selectedContents[i] = this.selectedObj[i]
          }
          else if (index === 1 && reg.test(i)) {
            this.selectedContents[i.match(reg)[1]] = this.selectedObj[i]
          }
        }


      },
      getLocalRelation() {
        let arr = relationData
        arr.sort((a, b) => {
          return a.parent_id > b.parent_id ? 1 : -1
        })
        arr[arr.length - 1].children = []

        for (let i = arr.length; i--;) {
          if (arr[i].parent_id > 0) {
            let obj = arr.pop()
            arr.forEach(item => {
              if (item.id === obj.parent_id) {
                item.children = item.children || []
                item.children.push(obj)
              }
            })
          }
        }
        this.data1 = arr[0]
      },
      getRelation() {
        $.ajax({
          url: config.baseURL + 'category/all',
        }).then((res) => {
          let arr             = res.data,
              tempOtherParent = []

          arr.sort((a, b) => {
            if (a.parent_id > b.parent_id) {
              return 1
            }
            else if (a.parent_id < b.parent_id) {
              return -1
            }
            else {
              if (a.order > b.order) {
                return 1
              }
              else {
                return -1
              }
            }
          })
          for (let i = arr.length; i--;) {
            if (typeof arr[i].other_parent_id === 'number') {
              tempOtherParent.push(arr[i])
            }
            if (arr[i].parent_id > 0) {
              let obj = arr.pop()
              arr.forEach(item => {
                if (item.id === obj.parent_id) {
                  item.children = item.children || []
                  item.children.unshift(obj)
                }
              })
            }
          }
          tempOtherParent.forEach(item => {
            findId2Insert(arr[0], item)
          })
          this.data1 = arr[0]

          setTimeout(() => {
            this.nodeEl.scrollLeft = (this.nodeEl.scrollWidth - this.nodeEl.offsetWidth) / 2
          })
        })
      },
    },
    components: {
      treeNode,
    },
  }
</script>

<style lang="less">
  .container {
    float: left;
    position: relative;
    padding: 10px;

    font-size: 14px;
    color: #333333;
    min-width: 100%;
    &:before {
      display: none;
      position: absolute;
      left: 0;
      top: -20px;
      width: 100%;
      height: 83px;
      background: url(../assets/top-line.png) center repeat-x;
      content: "";
    }

    .node-wrapper {
      position: fixed;
      left: 0;
      top: 40px;
      right: 0;
      bottom: 0;
      overflow: scroll;
    }

    .typography {
      position: relative;

      .l {
        float: left;
      }
      .r {
        float: right;
        position: relative;
        input[type="range"] {
          margin-top: 2px;
          width: 120px;
          height: 6px;
          background-color: #d1a251;
          box-shadow: inset 0 2px 2px #ac7633, 0 0 6px rgba(0, 0, 0, .2);
          outline: none;
          -webkit-appearance: none;
          border-radius: 10px;
          border: 1px rgba(255, 255, 255, .65) solid;

          &::-webkit-slider-thumb {
            position: relative;
            width: 28px;
            height: 28px;
            cursor: default;
            border-radius: 50%;
            border: 3px rgba(255, 255, 255, .8) solid;
            -webkit-appearance: none;
            background-image: linear-gradient(#955e15, #cc9d4d);

          }
        }
      }

      span {
        display: none;
        font-weight: 800;
        color: #000000;
      }
      i {
        display: inline-block;
        position: relative;
        margin-right: 10px;
        padding-left: 24px;
        height: 22px;
        line-height: 22px;
        color: #000000;
        cursor: pointer;

        &.checked {
          &:before {
            background-position: 0 0;
          }
        }

        &:before {
          position: absolute;
          left: 0;
          top: 0;
          width: 22px;
          height: 22px;
          background: url(../assets/checked.png);
          background-position: 0 -22px;
          content: "";
        }
      }
    }

    .ruler {
      display: none;
      position: absolute;
      top: 157px;
      bottom: 0;
      width: 20px;

      .i {
        position: relative;
        height: 117px;
        text-align: center;
        line-height: 14px;
        display: flex;
        align-items: center;
        padding-bottom: 15px;
        cursor: pointer;

        &:before,
        &:after {
          position: absolute;
          left: 0;
          width: 20px;
          height: 10px;
          content: "";

        }
        &:before {
          top: 5px;
          background-image: url(../assets/ruler-ico1.png);
        }
        &:after {
          bottom: 20px;
          background-image: url(../assets/ruler-ico2.png);
        }

        &:hover {
          em {
            display: block;
          }
        }

        em {
          display: none;
          position: absolute;
          width: calc(100vw - 1px);
          top: 0;
          height: 100px;
          background-color: rgba(233, 139, 0, .2);
        }
      }
    }
    .left-ruler {
      left: 10px;
      .i {
        em {
          left: -10px;

        }
      }
    }
    .right-ruler {
      right: 10px;
      .i {
        em {
          right: -10px;
        }
      }
    }

    .mask-box {
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 2;

      .bg {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, .5);
      }
      .mask {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 580px;
        height: 533px;
        max-width: 90%;
        max-height: 80%;
        transform: translateX(-50%) translateY(-50%);
        background: url(../assets/mask-bg.jpg) center no-repeat;
        background-size: 100% 100%;

        .close {
          position: absolute;
          right: -10px;
          top: -10px;
          width: 31px;
          height: 31px;
          background: url(../assets/close.png);
          background-size: contain;
          cursor: pointer;
        }
        .inner {
          position: absolute;
          left: 20px;
          top: 30px;
          right: 20px;
          bottom: 30px;
          overflow-y: scroll;
          -webkit-overflow-scrolling: touch;

          &::-webkit-scrollbar {
            width: 0;
          }

          .inner-scroll {
            .tab {
              border-bottom: 1px #d5b98f solid;
              li {
                display: inline-block;
                width: 110px;
                line-height: 40px;
                color: #b17b2d;
                text-align: center;
                font-weight: 800;
                cursor: pointer;

                &.on {
                  background-image: linear-gradient(#91581c, #ede0c8);
                  border-top-left-radius: 4px;
                  border-top-right-radius: 4px;
                  color: #ffffff;

                }
              }
            }
            .top {
              //display: flex;
              align-items: center;
              margin-bottom: 40px;
              padding-bottom: 40px;
              border-bottom: 1px #918063 dotted;

              .l {
                text-align: center;
                .img-cover {
                  display: inline-block;
                  position: relative;

                  width: 100px;
                  height: 100px;
                  border-radius: 50%;
                  background-image: url(../assets/photo.jpg);
                  background-size: cover;

                  &:after {
                    position: absolute;
                    left: 0;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    background: url(../assets/photo-mask.png) center;
                    background-size: cover;
                    content: "";
                  }
                }
              }
              .r {
                margin: 10px 20px 0 20px;
                color: #876535;
                line-height: 30px;
                span {
                  font-weight: 800;
                }
              }
            }

            .bottom {
              .tit {
                margin-bottom: 10px;
                color: #000000;
                font-weight: 800;
              }
              p {
                color: #876535;
                line-height: 30px;
              }
            }
          }
        }
      }
    }
  }

  @media (min-width: 768px) {
    .container {
      margin-top: 400px;
      padding: 20px 60px 40px 60px;
      background: url(../assets/con-bg.png) repeat;

      &:before {
        display: block;
      }

      .ruler {
        display: block;
      }

      .typography {
        span {
          display: inline-block;
        }

        .r {
          display: none;
        }
      }

      .node-wrapper {
        position: static;
        left: 0;
        top: 40px;
        right: 0;
        bottom: 0;
        overflow: inherit;
      }

      .mask-box {
        .mask {
          .inner {
            margin: 20px 30px;

            .inner-scroll {
              .top {
                display: flex;
                .l {
                  .img-cover {
                    margin-left: 20px;
                    margin-right: 50px;
                    width: 126px;
                    height: 126px;
                  }
                }
                .r {
                  margin: 0;
                }
              }
            }
          }
        }
      }
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/tree.vue